/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import * as Yup from 'yup';

import {
  Avatar,
  Box,
  Container,
  List,
  ListSubheader,
  ListItem,
  Stack,
  useMediaQuery,
} from '@mui/material';


import { BaseDiv } from './styles';
import { Header } from '../../components/Header';
import { MainContent } from '../../components/layout/Home/MainContent';
import { Footer } from '../../components/Footer';
import { Contact } from '../../components/layout/Home/Contact';



const Home: React.FC = () => {

  const ref: any = React.useRef(null);
  const refmid = React.useRef(null);
  const [dadosRef, setDadosRef] = React.useState(null);
  const [refTitle, setRefTitle] = React.useState(null);

  const matches = useMediaQuery('(max-width:800px)');
  const matches2 = useMediaQuery('(max-width:1100px)');

  React.useEffect(() => {
    const handleResize = () => {
      setDadosRef(ref.current);
      setRefTitle(ref?.current?.title)
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [dadosRef, ref]);

  return (
    <BaseDiv>
      <Box>
          <Header reference={dadosRef} title={refTitle}/>
          <MainContent />
          <Contact />
          <Footer />
      </Box>
    </BaseDiv>
  );
}

export { Home }